export default __webpack_public_path__ + "images/AX.45f27ab.png";